'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createHash(length) {
  var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  var text = '';
  length = length || 6;

  for (var i = 0; i < length; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return text;
}

var ADS_BLOCK_RESOURCES = ['https://adpass.atresmedia.com/***/ad-overlay.js', 'https://adpass.atresmedia.com/***/ad_banner.js', 'https://adpass.atresmedia.com/***/ad-manager/ads.js', 'https://adpass.atresmedia.com/***/ad-managment/adv.js', 'https://adpass.atresmedia.com/***/ads-module/', 'https://adpass.atresmedia.com/***/admanagers/', 'https://assets.adobedtm.com/***/noadtry.txt'];

exports.default = function () {
  var randomResourceIndex = Math.floor(Math.random() * ADS_BLOCK_RESOURCES.length);
  var randomHash = createHash(8);
  return new Promise(function (resolve) {
    var randomResource = ADS_BLOCK_RESOURCES[randomResourceIndex].replace('***', randomHash);
    var request = new Request(randomResource, {
      mode: 'no-cors'
    });
    fetch(request).then(function (res) {
      if (res.status === 404 || res.status === 0) {
        return resolve(false);
      }
    }).catch(function () {
      return resolve(true);
    });
  });
};